import React, { useEffect, useState } from 'react';
import { constants } from '../../../misc/constants';
import { getWindowVariable, reactToSmeDebug } from '../../../misc/tools';
import { BaseConfig } from '../../BaseConfig';
import { UIProperties } from '../../UIProperties';
import { SideMenuUIConfig } from './SideMenu';

var interval: any = null;
var update = false;
var alreadyFinishedInduction = false;
var forceStop=false;
var pause=false;
var animateAnimation = false;

var initialApneaTimeInSeconds = 0;

(window as any)['stopApneaTimer'] = () => {
	forceStop = true;
}

(window as any)['setPauseApneaTimerState'] = (isPaused: boolean) => {
	pause = isPaused;
}

var waitingToEndScenario = false;

const ApneaClockUI = (props: UIProperties<ApneaClockUIConfig>) => {
	const [forceUpdate, setForceUpdate] = useState(false);
	const [isIdle, setIsIdle] = useState(undefined);

	const refreshInternalApneaTimer = () => {
		var timeRemaining = convertTime(initialApneaTimeInSeconds - props.parameters.apneaTimeInSeconds).split(':');
		(window as any)['apneaTimeMinutes'] = timeRemaining[0];
		(window as any)['apneaTimeSeconds'] = timeRemaining[1];
	}
	useEffect(() => {
		(window as any).apneaTimerRefresh = (sideMenuParams: SideMenuUIConfig) => {
			var changed = false;
			if(typeof(sideMenuParams.isApneaTimerIdle) !== 'undefined') {
				props.parameters.isIdle = sideMenuParams.isApneaTimerIdle;
				setIsIdle(sideMenuParams.isApneaTimerIdle);
				changed = true;
			}

			if(typeof(sideMenuParams.apneaTimeInSeconds) !== 'undefined') {
				initialApneaTimeInSeconds = sideMenuParams.apneaTimeInSeconds;
				animateAnimation = sideMenuParams.resetEtc02;
				if(animateAnimation) {
					// var percentage = 1 - (props.parameters.apneaTimeInSeconds / sideMenuParams.apneaTimeInSeconds);
					// var maxIncrease = percentage * sideMenuParams.apneaTimeInSeconds;
					// var totalCalls = 220 * 5;
					// var step = maxIncrease / totalCalls; 
					var step = 0.1; 

					var currentVal = props.parameters.apneaTimeInSeconds;
					var int = setInterval(() => {
						currentVal += step;
						props.parameters.apneaTimeInSeconds = currentVal;
						props.parameters.apneaTimeInSeconds = Math.round(props.parameters.apneaTimeInSeconds);

						if(props.parameters.apneaTimeInSeconds >= sideMenuParams.apneaTimeInSeconds) {
							clearInterval(int);
							props.parameters.apneaTimeInSeconds = sideMenuParams.apneaTimeInSeconds;
							animateAnimation = false;
						}
						update = !update;
						setForceUpdate(update);
					}, 0)
				} else {
					props.parameters.apneaTimeInSeconds = sideMenuParams.apneaTimeInSeconds;
				}
				changed = true;
			}

			if(typeof(sideMenuParams.inductionTimeInSeconds) !== 'undefined') {
				props.parameters.inductionTimeInSeconds = sideMenuParams.inductionTimeInSeconds;
				alreadyFinishedInduction = false;
				changed = true;
			}

			if(changed) {
				setForceUpdate(!forceUpdate);
			}
		}
		if(!interval) {
			reactToSmeDebug('ApneaClockUI', () => {
				var testInductionTime = getWindowVariable(constants.smeDebug.variables.apneaInductionTime);
				var testapneaTime = getWindowVariable(constants.smeDebug.variables.apneaApneaTime);
				
				props.parameters.inductionTimeInSeconds = testInductionTime;
				props.parameters.apneaTimeInSeconds = testapneaTime;
			});

			initialApneaTimeInSeconds = props.parameters.apneaTimeInSeconds;
			refreshInternalApneaTimer();

			interval = setInterval(() => {
				if(props.parameters.isIdle || forceStop || pause || animateAnimation) {
					return;
				}
				if(!alreadyFinishedInduction && props.parameters.inductionTimeInSeconds <= 0) {
					props.parameters.onInductionTimerRanOut();
					alreadyFinishedInduction = true;
				}
				if(props.parameters.inductionTimeInSeconds >= 0) {
					props.parameters.inductionTimeInSeconds--;
				} else {
					props.parameters.apneaTimeInSeconds--;
					if(props.parameters.apneaTimeInSeconds < 0) {
						props.parameters.apneaTimeInSeconds = 0;
					}
					refreshInternalApneaTimer();
					if(props.parameters.apneaTimeInSeconds === 0 && !waitingToEndScenario) {
						setTimeout(() => {
							props.parameters.onApneaTimerRanOut();
						}, 3000);
						waitingToEndScenario = true;
					}
				}
				update = !update;
				setForceUpdate(update);
			}, 1000);
		}
		
		return () => {
			// if(interval) {
			// 	clearInterval(interval);
			// 	interval = null;
			// }
		}
	}, [forceUpdate]);
	
	const convertTime = (timeInSeconds: number) => {
		if(timeInSeconds < 0) {
			timeInSeconds = 0;
		}
		var minutes = Math.floor(timeInSeconds / 60);
		var seconds = timeInSeconds - (minutes * 60);

		if(minutes < 0) {
			minutes = 0;
		}

		if(seconds < 0) {
			seconds = 0;
		}

		var resMinutes = minutes < 10 ? '0' + minutes : minutes;
		var resSeconds = seconds < 10 ? '0' + seconds : seconds;

		return resMinutes + ':' + resSeconds;
	}
	const convertTime508 = (timeInSeconds: number) => {
		if(props.parameters.isIdle) {
			return 'not started';
		}

		var time = convertTime(timeInSeconds);
		var timeSplit = time.split(':');

		timeSplit[0] = timeSplit[0][0] === '0' && timeSplit[0].length > 1 ? timeSplit[0][1] : timeSplit[0];
		timeSplit[1] = timeSplit[1][0] === '0' && timeSplit[1].length > 1 ? timeSplit[1][1] : timeSplit[1];

		return timeSplit[0] + ' minutes and ' + timeSplit[1] + ' seconds';
	}

	const getTitle = () => {
		if(props.parameters.isIdle) {
			return 'not set';
		}
		return props.parameters.inductionTimeInSeconds >= 0 ? 'Induction' : 'Apnea';
	}

	const getTime = () => {
		if(props.parameters.isIdle) {
			return '--:--';
		} else {
			if(props.parameters.inductionTimeInSeconds >= 0) {
				return convertTime(props.parameters.inductionTimeInSeconds);
			} else {
				return convertTime(props.parameters.apneaTimeInSeconds);
			}
		}
	};
	return (
		<div className="modal-disable-select" style={{
			position: 'absolute',
			top: '271px',
			right: '110px',
			width: '250px',
			height: '120px',
			border: '3px solid rgb(192, 161, 6)',
			backgroundColor: 'rgb(36, 36, 36)',
			pointerEvents: 'all',
		}} tabIndex={0} aria-label={(props.parameters.inductionTimeInSeconds > 0 && !props.parameters.isIdle ? 'Induction Time. ' : 'Apnea Clock. ') + convertTime508(props.parameters.inductionTimeInSeconds >= 0 ? props.parameters.inductionTimeInSeconds : props.parameters.apneaTimeInSeconds)} id={'monitor-apnea-clock'} >
			<p style={{
				margin: '0px',
				fontSize: '20pt',
				textAlign: 'center',
				position: 'relative',
				top: '8px',
				opacity: props.parameters.isIdle ? '0' : '1',
				color: !props.parameters.isIdle && props.parameters.inductionTimeInSeconds >= 0 ? '#EFDC07' : 'white'
			}} className="title-font">{getTitle()}</p>
			<p style={{
				margin: '0px',
				fontSize: '40pt',
				textAlign: 'center',
				position: 'absolute',
				top: '50px',
				width: '100%',
				color: !props.parameters.isIdle && props.parameters.inductionTimeInSeconds >= 0 ? '#EFDC07' : 'white'
			}} className="title-font">{getTime()}</p>
		</div>
	);

};

export interface ApneaClockUIConfig extends BaseConfig{
	inductionTimeInSeconds: number;
	apneaTimeInSeconds: number;
	isIdle: boolean;
	onApneaTimerRanOut: () => void;
	onInductionTimerRanOut?: () => void;
}

export default ApneaClockUI;